<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w card-shadow" v-loading="loading">
    <p class="w100 bold mb20 font-18 tx-c">环节响应效率</p>

    <div class="w100 flex-box al-c sift-view">
      <DateComp ref="date" :loading="loading" @change="fetchList" />
    </div>

    <div class="w100 mt20 flex-box al-c" v-if="selectList.length">
      <span>选择部门：</span>
      <div>
        <el-select class="flex-1" v-model="selected" value-key="id" filterable placeholder="可输入筛选" @change="changeSelect" :disabled="loading">
          <el-option v-for="(item, index) in selectList" :key="index" :label="item.label" :value="item"></el-option>
        </el-select>
      </div>
      <div class="ml10">
        <el-autocomplete v-model="searchText" value-key="label" placeholder="可输入服务关键字搜索" clearable :fetch-suggestions="querySearch" @select="searchTextSelect"></el-autocomplete>
      </div>
      <div class="ml10">
        <el-button type="primary" size="mini" @click="fetchList">查询</el-button>
      </div>
    </div>

    <div class="w100 mt20 flex-box al-c">
      <span>显示类型：</span>
      <div>
        <el-button :type="chartType == 'dbfwsl' ? 'success' : ''" size="mini" @click="chartType = 'dbfwsl'">待办服务数量</el-button>
        <el-button :type="chartType == 'hjxysc' ? 'primary' : ''" size="mini" @click="chartType = 'hjxysc'">环节响应时长</el-button>
      </div>
    </div>

    <div class="w100 mt20 po-r serve-count-table">
      <p class="w100 mt20 mb20 pt20 pb20 tx-c grey" v-if="list.length == 0">暂无数据</p>
      <ve-histogram width="100%" height="500px" :grid="grid" :yAxis="yAxis" :series="series" :xAxis="xAxis" :legend="legend" v-else></ve-histogram>
    </div>
  </div>
</template>

<script>
import DateComp from "@/components/public/DateComp";

export default {
  name: "ServeCountForLink",
  components: {
    DateComp
  },
  props: ["queryRang"],
  data() {
    return {
      loading: false,

      selectList: [],
      selected: "",
      searchText: "",
      chartType: "dbfwsl",
      grid: {
        left: "20px",
        right: "20px",
        top: 60,
        bottom: 10,
        show: true,
        containLabel: true
      },
      // yAxis: [
      //   {
      //     type: "value",
      //     name: "办理数(个)",
      //     minInterval: 1
      //   },
      //   {
      //     type: "value",
      //     name: "时长(h)",
      //     splitLine: {
      //       show: false
      //     },
      //     axisLabel: {
      //       formatter: "{value} h"
      //     }
      //   }
      // ],
      // legend: {
      //   data: ["待办服务数量", "环节响应时长"]
      // },
      list: []
    };
  },
  created() {},
  computed: {
    legend() {
      if (this.chartType == "dbfwsl") {
        return {
          data: ["待办服务数量"]
        };
      }
      return {
        data: ["环节响应时长"]
      };
    },
    yAxis() {
      if (this.chartType == "dbfwsl") {
        return {
          type: "value",
          name: "办理数(个)",
          minInterval: 1
        };
      }
      return {
        type: "value",
        name: "时长(h)",
        axisLabel: {
          formatter: "{value} h"
        }
      };
    },
    xAxis() {
      if (this.list.length) {
        return {
          type: "category",
          axisLabel: {
            interval: 0,
            rotate: 15
          },
          data: this.list.map(val => val.lingName),
          axisPointer: {
            type: "shadow"
          }
        };
      }
      return null;
    },
    series() {
      if (this.list.length) {
        if (this.chartType == "dbfwsl") {
          return {
            type: "bar",
            name: "待办服务数量",
            barMaxWidth: "40px",
            itemStyle: {
              color: "#67C23A"
            },
            data: this.list.map(val => val.taskNum)
          };
        }
        return {
          type: "bar",
          name: "环节响应时长",
          barMaxWidth: "40px",
          itemStyle: {
            color: "#409EFF"
          },
          data: this.list.map(val => (val.costTime / 3600000).toFixed(2))
        };
      }
      return null;
    }
  },
  mounted() {
    this.fetchSelectList();
  },
  methods: {
    fetchList() {
      this.loading = true;

      const date = this.$refs.date.getValue();
      this.$http
        .post(
          "serveCount/linkRanking",
          JSON.stringify({
            startDate: date[0],
            endDate: date[1],
            queryRang: this.queryRang,
            processDefId: this.selected.id
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchSelectList() {
      this.loading = true;

      this.$http
        .post("serve/query", this.$qs.stringify())
        .then(({ data }) => {
          if (data.RetCode) {
            let arr = [];
            for (const item of data.RetData) {
              for (const val of item.serveList) {
                if (val.serveType == 1) {
                  arr.push({
                    id: val.id,
                    label: val.serveName
                  });
                }
              }
            }
            this.selectList = arr;
            this.selected = arr[0];
            this.$nextTick(() => {
              this.fetchList();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    querySearch(queryString, cb) {
      const selectList = this.selectList;
      const results = queryString
        ? selectList.filter(this.createFilter(queryString))
        : selectList;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    changeSelect(item) {
      this.searchText = item.label;
      this.$nextTick(() => {
        this.fetchList();
      });
    },
    searchTextSelect(item) {
      this.selected = item;
      this.$nextTick(() => {
        this.fetchList();
      });
    }
  }
};
</script>

<style scoped>
</style>
